const TIA_HOSTNAMES = new Set(['asktia.com', 'www.asktia.com'])

export const shouldOpenInNewTab = (url?: string) => {
  if (!url) return false

  try {
    const parsedUrl = new URL(url)

    return (
      ['http:', 'https:'].includes(parsedUrl.protocol) &&
      !TIA_HOSTNAMES.has(parsedUrl.hostname.toLowerCase())
    )
  } catch {
    return false
  }
}

export const getExternalLinkTargetProps = (url?: string) =>
  shouldOpenInNewTab(url)
    ? {
        target: '_blank' as const,
        rel: 'noopener noreferrer',
      }
    : {}
